<template lang="html">
  <div>
      <div v-if="el.is_community_suggested">
        <v-badge
        overlap
        color="green"
        icon="done"
        >
        <v-btn color="blue" icon disabled>
          <v-icon>publish</v-icon>
        </v-btn>
      </v-badge>
      </div>
      <div v-else>
        <v-btn color="blue" icon @click="$emit('communitSuggestClick', el)">
          <v-icon>publish</v-icon>
        </v-btn>
      </div>
  </div>
</template>

<script>
export default {
  name: 'CommunitySuggestBtn',
  props: ['el']
}
</script>

<style lang="css" scoped>
</style>
